import clsx from 'clsx'
import classes from './MonitorStatus.module.scss'

export default function MonitorStatus() {
  return (
    <div className={classes.tableWrap}>
      <table>
        <thead>
          <tr>
            <th>Flow</th>
            <th>Records Imported</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Import Companies</td>
            <td>12</td>
            <td>
              <div className={classes.statusWrap}>
                <div
                  className={clsx(classes.status, classes.statusComplete)}
                ></div>
                Completed
              </div>
            </td>
          </tr>
          <tr>
            <td>Import Contacts</td>
            <td>108</td>
            <td>
              <div className={classes.statusWrap}>
                <div
                  className={clsx(classes.status, classes.statusComplete)}
                ></div>
                Completed
              </div>
            </td>
          </tr>
          <tr>
            <td>Import Users</td>
            <td>71</td>
            <td>
              <div className={classes.statusWrap}>
                <div
                  className={clsx(classes.status, classes.statusFailed)}
                ></div>
                Failed : 3
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
